import login from './login';
import router from './router';

export default [login, router];
